import {
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILURE,
  FETCH_USER_DELETETOKEN,
  FETCH_ERROR_DELETE,
  FETCH_USER_PAGE,
} from "./ActionTypes";

const initialState = {
  isLoading: false,
  usertoken: localStorage.getItem("natusToken"),
  error: false,
  page: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_USER_SUCCESS:
      localStorage.setItem("natusToken", action.payload);
      return {
        ...state,
        isLoading: false,
        usertoken: action.payload,
        error: false,
      };
    case FETCH_USER_PAGE:
      localStorage.setItem("natusPage", action.payload);
      return {
        ...state,
        isLoading: false,
        page: action.payload,
        error: false,
      };
    case FETCH_USER_FAILURE:
      localStorage.removeItem("natusToken");
      localStorage.removeItem("natusPage");
      return {
        ...state,
        isLoading: false,
        usertoken: null,
        error: true,
      };
    case FETCH_USER_DELETETOKEN:
      localStorage.removeItem("natusToken");
      localStorage.removeItem("natusPage");
      return {
        isLoading: false,
        usertoken: null,
      };
    case FETCH_ERROR_DELETE:
      localStorage.removeItem("natusToken");
      localStorage.removeItem("natusPage");
      return {
        ...state,
        isLoading: false,
        error: false,
      };

    default:
      return state;
  }
};

export default reducer;
